import { formatISO } from 'date-fns';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useGetWorkerDailyDuesDetails } from '@/modules/workingDayReconciliation/apiHooks';
import { getWorkersTable } from '@/modules/workingDayReconciliation/components/WorkerDailyDuesSummary/DetailedCard/logic';
import { WorkingDayReconciliationContext } from '@/modules/workingDayReconciliation/context/context';
import { IReconciliation } from '@/modules/workingDayReconciliation/types';
import { Loading, Table } from '@/shared/components/atoms';
import { EmptyCard } from '@/shared/components/molecules';
import { useStore } from '@/shared/hooks/context/createGenericContext';

const PER_PAGE = 10;
const DetailedCard: React.FC<{
  date: Date;
}> = ({ date }) => {
  const { t } = useTranslation('common');
  const [pageNumber, setPageNumber] = useState(1);
  const [selectedAsset] = useStore((store) => store?.asset);
  const {
    state: { workerId },
  } = useContext(WorkingDayReconciliationContext);

  const { data, isLoading } = useGetWorkerDailyDuesDetails({
    entityId: selectedAsset?.id,
    date: formatISO(date, { representation: 'date' }),
    pageNumber,
    pageSize: PER_PAGE,
    workerId,
  });

  if (isLoading) {
    return <Loading />;
  }
  if (data?.workers?.length === 0 || !data) {
    return <EmptyCard message={t('no-workers-found')} variant='text' />;
  }

  return (
    <Table<IReconciliation.IGetWorkerDailyDuesDetails>
      pagination={true}
      currentPage={pageNumber}
      totalCount={data.totalCount}
      onPageChange={(pageNumber) => {
        setPageNumber(pageNumber);
      }}
      paginationWrapperClassName='!mt-24'
      perPage={PER_PAGE}
      selection={false}
      data={data.workers ?? []}
      columns={getWorkersTable(t, selectedAsset?.currency ?? '')}
      footerClassName='bg-neutralVariant-95'
      headCellClassName='text-start border-b-xs border-neutralVariant-90 text-surface-10 font-semi-bold'
      rowCellClassName='border-b-xs border-neutralVariant-90'
      headContainerClassName='!bg-background-neutral-99'
      tableWrapperClassName='!rounded-xl border-xs border-outline-variant'
    />
  );
};

export { DetailedCard };
